import * as React from 'react'
import Drawer from 'material-ui/Drawer'
import {
    ActionExitToApp,
    ActionFace,
    HardwareKeyboardArrowRight
} from 'material-ui/svg-icons'
import List from 'material-ui/List/List'
import ListItem from 'material-ui/List/ListItem'
import Divider from 'material-ui/Divider'
import {Cis2User} from '../Entities/Cis2User'
import {Action} from './Actions'
import {Manufacturer} from '../Entities/Manufacturer.entity.evolve'
import injectSheet from 'react-jss'
import {WithClasses} from '../View/Helper'
import {url} from './AuthenticatedRoute'

const logo = require('../img/cis-logo.png')

const styles = {
    drawerHeader: {
        width: '100%'
    },
    drawerLogo: {
        width: '100%',
        padding: '40px',
        paddingTop: '24px',
        boxSizing: 'border-box',
        borderBottom: 'solid 1px rgb(224, 224, 224)'
    },
}

interface Properties {
    open: boolean,
    disabled: boolean,
    cis2User: Cis2User | null,
    manufacturer: Manufacturer | null,
    dispatch: (action: Action) => void
}

export const Navigation =
    injectSheet<Properties>(styles)(
        ({classes, open, disabled, cis2User, manufacturer, dispatch}: WithClasses<Properties>) => (
            <Drawer
                open={!disabled && open}
                docked={false}
                onRequestChange={value =>
                    dispatch({type: 'DrawerToggleAction', open: value})}
                className="drawer"
                disableSwipeToOpen={disabled}
            >
                <div className={classes.drawerHeader}>
                    <img
                        className={classes.drawerLogo}
                        src={logo}
                    />
                </div>
                <List>
                    {manufacturer !== null &&
                    <ListItem
                        primaryText="Prisma-Projekte"
                        leftIcon={<HardwareKeyboardArrowRight/>}
                        href={url({type: 'PrismaRequestOverview'})}
                    />
                    }
                </List>
                <Divider/>
                <List>
                    <ListItem
                        primaryText="Benutzer"
                        secondaryText={
                            cis2User !== null
                                ? `${cis2User.firstName} ${cis2User.lastName}`
                                : ''
                        }
                        leftIcon={<ActionFace/>}
                        href={url({type: 'PasswordChange'})}
                    />
                    <ListItem
                        primaryText="Logout"
                        leftIcon={<ActionExitToApp/>}
                        onTouchTap={() => dispatch({type: 'LogoutAction'})}
                    />
                </List>
            </Drawer>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App/Navigation.tsx